<template>
    <div class="tab_bar w-full">
        <div class="mdc-tab-bar top-tab-bar" role="tablist" id="examResultViewTab">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('ResultMy')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('75')}}
                                    <!-- 채점 결과 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="1" @click="changeTabType('RewardMy')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('76')}}
                                    <!-- 나의 리워드 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>

                        <button class="mdc-tab" role="tab" tabindex="2" @click="changeTabType('Information')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('78')}}
                                    <!-- 시험지 정보 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 시험 상세 탭바 정보
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.11
 */

// Components/Mixin/Extend/API 선언
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    props: ['setTabFixed'],
    data() {
        return {
            examResultViewTab: null,
            tabType: 'Information',
        }
    },
    mounted() {
        console.log('viewTabMounted');
        
        this.examResultViewTab = new MDCTabBar(document.querySelector('#examResultViewTab'))
    },

    updated() {
        this.examResultViewTab = new MDCTabBar(document.querySelector('#examResultViewTab'))

        if (this.tabType === 'ResultMy') {
            this.examResultViewTab.activateTab(0)
        }else if (this.tabType === 'RewardMy') {
            this.examResultViewTab.activateTab(1)
        }else if (this.tabType === 'Information') {
            this.examResultViewTab.activateTab(2)
        }else {
            this.examResultViewTab.activateTab(0)
        }
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            this.tabType = type
            this.$emit('setViewTab', type)
        }
        
    }

}
</script>

<style scoped>

</style>